'use client';

import styles from './Contact.module.css';
import { buildWhatsAppUrl, SALES_PHONE_READABLE, SUPPORT_PHONE_READABLE, SUPPORT_PHONE_E164 } from '@/utils/whatsapp';

export function Contact() {
  return (
    <main className={`container ${styles.page}`}>
      <section className={styles.hero}>
        <article className={styles.card}>
          <p className={styles.eyebrow}>İletişim</p>
          <h1 className={styles.title}>
            Ses Yalıtım Projeniz İçin <span className={styles.titleAccent}>Hızlı ve Net İletişim</span>
          </h1>
          <p className={styles.intro}>
            Keşif, metraj, ürün seçimi ve uygulama planı için doğrudan uzman ekibimize ulaşabilirsiniz. Türkiye&apos;nin her iline satış ve
            uygulama desteği veriyor; ekibimiz proje ihtiyaçlarına göre sahaya gidip ses yalıtımı sürecini yerinde yönetebiliyor.
          </p>

          <div className={styles.contactGrid}>
            <div className={styles.contactItem}>
              <p className={styles.contactLabel}>Sabit Hat</p>
              <a className={styles.contactValue} href={`tel:${SUPPORT_PHONE_E164}`}>
                {SUPPORT_PHONE_READABLE}
              </a>
            </div>
            <div className={styles.contactItem}>
              <p className={styles.contactLabel}>Satış Hattı</p>
              <a className={styles.contactValue} href={buildWhatsAppUrl('Merhaba, ses yalıtımı için bilgi almak istiyorum.')}>
                {SALES_PHONE_READABLE}
              </a>
            </div>
            <div className={styles.contactItem}>
              <p className={styles.contactLabel}>E-Posta</p>
              <a className={styles.contactValue} href="mailto:satis@tasarimakustik.com">
                satis@tasarimakustik.com
              </a>
            </div>
            <div className={styles.contactItem}>
              <p className={styles.contactLabel}>Proje E-Posta</p>
              <a className={styles.contactValue} href="mailto:proje@tasarimakustik.com">
                proje@tasarimakustik.com
              </a>
            </div>
          </div>

          <div className={styles.ctaRow}>
            <a className={`${styles.btn} ${styles.btnPrimary}`} href={buildWhatsAppUrl('Merhaba, ses yalıtımı için bilgi almak istiyorum.')}>
              WhatsApp ile Yaz
            </a>
            <a className={`${styles.btn} ${styles.btnSecondary}`} href="/urunler">
              Ürünleri İncele
            </a>
          </div>
        </article>

        <div className={styles.imageWrap}>
          <img className={styles.image} src="/images/bondex-8.webp" alt="Bondex sünger iletişim görseli" loading="lazy" />
        </div>
      </section>

      <section className={styles.card}>
        <h2 className={styles.serviceCardTitle}>Türkiye&apos;nin Her İline Satış + Uygulama Desteği</h2>
        <p className={styles.serviceText}>
          Sadece ürün gönderimi yapmıyoruz; her ile özel proje değerlendirmesi, metraj planı, ürün eşleştirme ve saha uygulama desteği
          veriyoruz. Ekibimiz gerekli durumlarda il bazlı yerinde keşif yaparak duvar, tavan ve zemin kaynaklı ses yalıtımı problemlerine
          doğru çözüm modeli oluşturuyor.
        </p>
        <ul className={styles.serviceList}>
          <li>81 ilde satış ve lojistik planlama</li>
          <li>Her ile özel teknik yönlendirme ve proje danışmanlığı</li>
          <li>Sahaya gelen ekiplerle uygulama koordinasyonu</li>
          <li>Konut, ofis, stüdyo, fabrika ve teknik hacim desteği</li>
        </ul>
      </section>

      <div className={styles.addressGrid}>
        <section className={styles.card}>
          <h3 className={styles.serviceCardTitle}>Ofis & Showroom</h3>
          <p className={styles.serviceText}>Osman Gazi Mah. Mimar Sinan Cad. No:11/A Sancaktepe / İstanbul</p>
        </section>
        <section className={styles.card}>
          <h3 className={styles.serviceCardTitle}>Fabrika</h3>
          <p className={styles.serviceText}>OSB Köşeler Mah. 3. Cadde No:20 Dilovası / Kocaeli</p>
        </section>
        <section className={styles.card}>
          <h3 className={styles.serviceCardTitle}>Bizi Arayın</h3>
          <p className={styles.serviceText}>
            {SUPPORT_PHONE_READABLE}
            <br />
            {SALES_PHONE_READABLE}
          </p>
        </section>
      </div>

      <h2 className={styles.sectionTitle}>Konumumuz</h2>
      <section className={styles.mapGrid}>
        <article className={styles.mapItem}>
          <h3 className={styles.mapTitle}>Ofis & Showroom Konumu</h3>
          <iframe
            className={styles.mapFrame}
            src="https://www.google.com/maps?q=Osman%20Gazi%20Mah.%20Mimar%20Sinan%20Cad.%20No%3A11%2FA%20Sancaktepe%20Istanbul&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ofis ve showroom konumu"
          />
        </article>
        <article className={styles.mapItem}>
          <h3 className={styles.mapTitle}>Fabrika Konumu</h3>
          <iframe
            className={styles.mapFrame}
            src="https://www.google.com/maps?q=OSB%20K%C3%B6%C5%9Feler%20Mah.%203.%20Cadde%20No%3A20%20Dilovas%C4%B1%20Kocaeli&output=embed"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Fabrika konumu"
          />
        </article>
      </section>

      <section className={styles.gallery} aria-label="Ofis ve proje görselleri">
        <img src="/images/bondex.webp" alt="Showroom görseli" loading="lazy" />
        <img src="/images/bariyerli.webp" alt="Akustik proje görseli" loading="lazy" />
      </section>
    </main>
  );
}
